export enum Role {
  TtAdmin = "TtAdmin",
  TtProxyAdmin = "TtProxyAdmin",
  TtAgent = "TtAgent",
  TtUser = "TtUser",
  LessorAdmin = "LessorAdmin",
  LessorProxyAdmin = "LessorProxyAdmin",
  LessorAgent = "LessorAgent",
  Lessee = "Lessee",

}
